import request from "@/utils/request";

export const categoryGroups = (param) => {
    return request({
        url: '/groups/category',
        method: 'post',
        data: param
    })
}

export const msvGroups = (param) => {
    return request({
        url: '/groups/msv',
        method: 'post',
        data: param
    })
}
export const saveGroups = (param) => {
    return request({
        url: '/groups/save',
        method: 'post',
        data: param
    })
}
export const delGroups = (param) => {
    return request({
        url: `/groups?ids=${param}`,
        method: 'DELETE',
    })
}
export const onDel = (param) => {
  return request({
      url: `/categoryLeader/delete`,
      method: 'post',
      data: param
  })
}
export default {
    categoryGroups: categoryGroups,
    msvGroups: msvGroups,
    saveGroups: saveGroups,
    delGroups: delGroups,
    onDel: onDel,

}